// client/src/constants/fonts.js

export const FONT_CATEGORIES = {
  'sans-serif': { label: 'Sans-serif', fonts: ['Inter', 'Poppins', 'DM Sans'] },
  'serif':      { label: 'Serif',      fonts: ['Lora', 'Playfair Display'] },
  'monospace':  { label: 'Monospace',  fonts: ['JetBrains Mono', 'Fira Code'] },
  'rounded':    { label: 'Rounded',    fonts: ['Nunito', 'Quicksand'] },
};

// CSS font-family value for each font (used in createTheme typography.fontFamily)
export const FONT_FAMILY = {
  'Inter':            "'Inter', sans-serif",
  'Poppins':          "'Poppins', sans-serif",
  'DM Sans':          "'DM Sans', sans-serif",
  'Lora':             "'Lora', serif",
  'Playfair Display': "'Playfair Display', serif",
  'JetBrains Mono':   "'JetBrains Mono', monospace",
  'Fira Code':        "'Fira Code', monospace",
  'Nunito':           "'Nunito', sans-serif",
  'Quicksand':        "'Quicksand', sans-serif",
};
